export enum FileManagerEvents {
  FILE_UPLOADED = 'file-uploaded',
  FILE_DOWNLOADED = 'file-downloaded',
  FILE_TRASHED = 'file-trashed',
  FILE_RECOVERED = 'file-recovered',
  FILE_FORGOTTEN = 'file-forgotten',
  FILE_VERSION_RESTORED = 'file-version-restored',
  SHARE_MESSAGE_SENT = 'file-shared',
  INITIALIZED = 'initialized',
  DRIVE_CREATED = 'drive-created',
  DRIVE_FORGOTTEN = 'drive-forgotten',
  DRIVE_DESTROYED = 'drive-destroyed',
  STATE_INVALID = 'state-invalid',
}
